import { useAppStore } from '@/shared/store/app.store.ts'
import useTracksStore from '@/shared/store/tracks.store.tsx'
import { WorkflowId } from '@/models'
import { billingClient } from '@/features/shared/data/api-client.ts'

export const AUDIOFORM_DOWNLOAD_EVENT = 'action-download-audioform'

export type DownloadAssetType = 'mix' | 'clip'

interface AudioformDownloadContext {
  assetType: DownloadAssetType
  audioformId?: string | undefined
  format?: string | undefined
}

/**
 * Billing counts each download as a usage event.
 * A failed report does not stop the download.
 */
const reportAudioformDownload = (audioformId: string): void => {
  billingClient
    .post('/console/usage_event', {
      assetId: audioformId,
      eventType: 'audioform_downloaded',
      client: WorkflowId.PRO_EDITOR,
    })
    .catch((error: unknown) => {
      console.error('Failed to report the download to billing:', error)
    })
}

export const trackAudioformDownload = (
  trackEvent: (event: string, properties?: Record<string, unknown>) => void,
  { assetType, audioformId, format }: AudioformDownloadContext
): void => {
  const { session } = useAppStore.getState()
  const resolvedAudioformId =
    audioformId ??
    useTracksStore.getState().generatedMix?.id ??
    session?.audioformId

  trackEvent(AUDIOFORM_DOWNLOAD_EVENT, {
    asset_type: assetType,
    workflow_id: WorkflowId.PRO_EDITOR,
    ...(resolvedAudioformId ? { audioform_id: resolvedAudioformId } : {}),
    ...(session?.sessionId ? { session_id: session.sessionId } : {}),
    ...(format ? { format } : {}),
  })

  if (resolvedAudioformId) {
    reportAudioformDownload(resolvedAudioformId)
  }
}
